<template>
  <div class="page-2-container fixed-input-wrapper">
    <div class="header-wrapper">
      <span class="__title">Tentukan Lokasi</span>
      <McButton
        icon="icon-fill_close"
        variant="minimal"
        text=""
        @click="handleBack"
      />
    </div>
    <MapSelectPoint
      :modelValue.sync="localAddress"
      :optionType="[GOOGLE_MAP_ADDRESS_TYPE]"
      @update:modelValue="updateAddress"
    />
    <div class="footer-wrapper">
      <McButton class="btn-back" variant="minimal" text="Kembali" @click="handleBack" />
      <McButton class="btn-send" text="Kirim" :disabled="localAddress == null" @click="handleSubmit" />
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import MapSelectPoint from '../../MapSelectPoint'

import { EventBus } from '../../../lib/event-bus'

import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'

import { GOOGLE_MAP_ADDRESS_TYPE } from '../../../lib/constants/types'

export default {
  components: {
    McButton,
    MapSelectPoint,
  },
  emits: ['change-page'],
  data() {
    return {
      GOOGLE_MAP_ADDRESS_TYPE,

      localAddress: {},
    }
  },
  computed: {
    ...mapState('trackingTemp', ['formValues']),
  },
  beforeMount() {
    this.localAddress = cloneDeep(this.formValues.address)
  },
  methods: {
    handleBack() {
      this.$emit('change-page', 1)
    },
    handleSubmit() {
      this.$store.dispatch('trackingTemp/setAddress', this.localAddress)
      EventBus.$emit('handle-submit-notif-wa')
    },
    updateAddress(val) {
      this.localAddress = val
      this.$store.dispatch('trackingTemp/setAddress', this.localAddress)
    }
  }
}
</script>
